import React, { useState } from 'react'
import { ModalEditSupplierContact } from '../modals/ModalEditSupplierContact'
import { Grower, GrowerField, GrowersList, Supplier, SupplierContact, SupplierList } from '../../interfaces/interfaces.auth'
import { IoCreateOutline, IoMailOutline, IoPersonOutline } from 'react-icons/io5'
import { LuSprout, LuSquarePen, LuEarth, LuMapPin, LuTrash2 } from "react-icons/lu";
import { ModalAddField } from '../modals/ModalAddField';
import { ModalConfirmation } from '../ui/ModalConfirmation';
import { useRemoveField } from '../../api/useGrower';
import { useDispatch } from 'react-redux';
import { startChecking } from '../../store/asyncMethods/authMethods';

interface Props {
    grower: Grower
    target: GrowersList
    field: GrowerField
}

export const Field = ({ grower, target, field }: Props) => {

    const dispatch = useDispatch()
    
    const [modalEditField, setModalEditField] = useState<boolean>(false)
    const [confirmation, setConfirmation] = useState<boolean>(false)
    const { mutate, isLoading } = useRemoveField()

    const removeField = () => {
        mutate({
            id: target.id,
            model: target.model,
            growerId: grower._id,
            fieldId: field._id
        }, {
            onSuccess: () => {
                dispatch(startChecking())
                setConfirmation(false)
            },
            onError: (error) => console.log(error)
        })
    };

    const classNameField = "tw-text-sm tw-flex tw-gap-1 md:tw-items-center"

    return (
        <>
            {
                modalEditField &&
                <ModalAddField
                    grower={grower}
                    closeModal={() => setModalEditField(false)}
                    target={target}
                    field={field}
                />
            }

            {
                confirmation &&
                <ModalConfirmation
                    action={removeField}
                    closeConfirmation={() => setConfirmation(false)}
                    msg="Are you sure you want to remove this field?"
                    buttonName="Remove"
                    isLoading={isLoading}
                />
            }

            <div className="tw-grid tw-grid-cols-[1fr_1fr_1fr_auto] tw-gap-2 tw-py-3" key={field.name}>
                <p className={classNameField}><LuSprout /> {field.name}</p>
                <p className={classNameField}><LuEarth /> {field.country}, {field.city}</p>
                <p className={classNameField}><LuMapPin /> {field.coords.lat}, {field.coords.lon}</p>
                <div className='tw-flex tw-px-4 tw-gap-4 tw-items-center'>
                    <button
                        onClick={() => setConfirmation(true)}
                    ><LuTrash2 />
                    </button>
                    <button
                        onClick={() => setModalEditField(true)}
                    ><LuSquarePen />
                    </button>
                </div>
            </div>
        </>
    )
}
